// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"4c6d26ef","3252":"4c6d26ef","4076":"4c6d26ef","5836":"318ee721","5861":"4c6d26ef","6167":"4c6d26ef","6535":"4c6d26ef","8037":"4c6d26ef","9217":"91122c81"}[chunkId] + ".chunk.css";
};